"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePiecePlacement = resolvePiecePlacement;
const models_1 = require("@creature-chess/models");
const board_1 = require("@creature-chess/board");
function resolvePiecePlacement(sourcePieceId, target, board, bench) {
    const targetBoard = target.type === "board" ? board : bench;
    const [x, y] = (0, board_1.unpackPosition)(target.location);
    const occupant = targetBoard.getPieceIdAtPosition(x, y);
    if (occupant === sourcePieceId) {
        return { kind: "noop" };
    }
    if (occupant !== null) {
        return {
            kind: "swap",
            action: models_1.PlayerActions.swapPiecePlayerAction({
                pieceAId: sourcePieceId,
                pieceBId: occupant,
            }),
        };
    }
    return {
        kind: "drop",
        action: models_1.PlayerActions.dropPiecePlayerAction({
            pieceId: sourcePieceId,
            to: target,
        }),
    };
}
